import { API_HOST_NAME } from '../../env.js';
import request, { GET_REQUEST, POST_REQUEST } from '@helpers/request.js';

export const apiEndpoint = {
  residenceList: API_HOST_NAME + '/lead/provinces',
  occupationList: API_HOST_NAME + '/lead/occupations',
  validatePhone: API_HOST_NAME + '/lead/validate-phone',
  validateAgent: API_HOST_NAME + '/lead/validate-agent',
  saveLeadAndSendToSalesforce:
    API_HOST_NAME + '/lead/save-lead-and-send-to-salesforce',
  getSourceOfLeadLov: API_HOST_NAME + '/lead/source-of-lead-lov',
  getBankBranchCode: API_HOST_NAME + '/lead/filter-bank-branch-team',
  getLeadAgentBranchInformation:
    API_HOST_NAME + '/lead/get-agent-branch-information',
  getLeadActivities: API_HOST_NAME + '/lead/get-activities',
  getLeadHistory: API_HOST_NAME + '/lead/get-input-history',
  getAgentPenalties: API_HOST_NAME + '/lead/agent-penalties',
  validateChannelAndCategory: API_HOST_NAME + '/lead/validate-channel-category',
};

export const getResidenceListService = () => {
  return GET_REQUEST(apiEndpoint.residenceList, {});
};

export const getOccupationListService = () => {
  return GET_REQUEST(apiEndpoint.occupationList, {});
};

export const validatePhoneService = (clientPhoneNumber) => {
  return POST_REQUEST(apiEndpoint.validatePhone, {
    phone: clientPhoneNumber,
  });
};

export const validateAgentService = (assignedAgentCode) => {
  return POST_REQUEST(apiEndpoint.validateAgent, {
    isAgentCode: assignedAgentCode,
  });
};

export const saveLeadAndSendToSalesforce = (leadRequest) => {
  return POST_REQUEST(apiEndpoint.saveLeadAndSendToSalesforce, {
    ...leadRequest,
  });
};

export const getSourceOfLeadLovService = () => {
  return GET_REQUEST(apiEndpoint.getSourceOfLeadLov, {});
};

export const getBankBranchService = ({ code, channel }) => {
  return GET_REQUEST(apiEndpoint.getBankBranchCode, { code, channel });
};

export const getLeadAgentBranchInformationService = (
  agentCode,
  channelCode,
  includeJobTitle = 0,
) =>
  GET_REQUEST(apiEndpoint.getLeadAgentBranchInformation, {
    agentCode,
    channelCode,
    includeJobTitle,
  });

export const getLeadActivityListService = (leadId, page, size) => {
  return GET_REQUEST(apiEndpoint.getLeadActivities, {
    leadId: leadId,
    page: page,
    size: size,
  });
};

export const getAgentPenalties = (agentCode) => {
  return GET_REQUEST(apiEndpoint.getAgentPenalties, {
    agentCode,
  });
};

export const getLeadHistoryService = (
  clientName,
  phone,
  fromDate,
  toDate,
  page,
  size,
) => {
  return GET_REQUEST(apiEndpoint.getLeadHistory, {
    clientName: clientName,
    phone: phone,
    fromDate: fromDate,
    toDate: toDate,
    page: page,
    size: size,
  });
};

export const validateChannelAndCategory = (
  agentCode,
  channelCode,
  categoryCode,
) => {
  return GET_REQUEST(apiEndpoint.validateChannelAndCategory, {
    agentCode,
    channelCode,
    categoryCode,
  });
};
